var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442",
    transform: "translate(-101 -312.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 12.292,
    height: 4.204,
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 130.576, 313.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 12.292,
    height: 4.204,
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 117.652, 316.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_watch_later_24px",
    d: "M23,2A21.1,21.1,0,1,0,44,23.1,21.114,21.114,0,0,0,23,2Zm8.82,29.967L20.9,25.214V12.552h3.15V23.525l9.45,5.7-1.68,2.743Z",
    transform: "translate(99 316.293)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.5d3059cfdd7b6ecdefa513c4d4786719.svg";
export { ForwardRef as ReactComponent };